import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private document = inject(DOCUMENT);
  private readonly window: CustomWindow = this.document
    .defaultView as CustomWindow;
  private readonly env: AppEnv = this.window.__env__;

  public get(key: keyof AppEnv) {
    if (key in this.env) {
      return this.env[key];
    }

    return undefined;
  }
}

type DocumentDefaultView = (Window & typeof globalThis) | null;

type CustomWindow = { __env__: AppEnv } & DocumentDefaultView;

export interface AppEnv {
  apiRoot: string;
  clientId: string;
  tenantId: string;
  authority: string;
  redirectUri: string;
  enableProdMode?: boolean;
}
